import { CaseWithIncidents } from '../types';

export function caseMeetsMinimumIncidents(
  caseWithIncidents: Pick<CaseWithIncidents, 'incidents_count'>,
  minimumIncidents: number,
): boolean {
  return caseWithIncidents.incidents_count >= minimumIncidents;
}
